import mapActions from './mapActions';

export default mapActions('cars_history', {
    fetchAll_url: (data) => `/api/cars_history/car/${data.car_id}`
});